import { render, staticRenderFns } from "./dilSecenekleri.vue?vue&type=template&id=22892dc8&"
import script from "./dilSecenekleri.vue?vue&type=script&lang=js&"
export * from "./dilSecenekleri.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports